"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetNavigationType = void 0;
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _utils = require("../utils");
// istanbul ignore file -- api

const useGetNavigationType = ({
  type,
  enabled = true,
  skipUserSegmentation = false
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    customerTypeId,
    visitorSegment,
    loading: loadingUserSegmentationData
  } = (0, _presentationHttp.useUserSegmentationData)();
  const {
    data,
    error,
    isLoading,
    isValidating
  } = (0, _staticApiClientReact.useGetTenantApplicationsNavigationExpandedNavigation)(tenant, type, {
    customerTypeId: customerTypeId ?? undefined,
    visitorSegment: visitorSegment ?? undefined,
    lang: language
  }, {
    swr: {
      enabled: enabled && (!loadingUserSegmentationData || skipUserSegmentation),
      ...(0, _presentationUtils.getRetryErrorSwrOptions)()
    }
  });
  return (0, _react.useMemo)(() => ({
    data: (0, _utils.mapNavigationData)(data?.data?.application?.navigation?.children),
    error,
    loading: isLoading || isValidating
  }), [data?.data?.application?.navigation?.children, error, isLoading, isValidating]);
};
exports.useGetNavigationType = useGetNavigationType;
